import { http } from '@/http/axios.js'
export function getLoginCodeAPI(mobile) {
  return http({
    url: '/capital/auth/login/code',
    method: 'post',
    data: { mobile }
  })
}
